import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Summary_1({ item, isSub }) {
  const isHtml = item.scale.isHtml;
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Detect if RGB color system is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper
  const colors = getScaleColors(item.scale);
  return (
    <Row className="mb-3 mx-0">
      <Col xs={4} className={"align-content-center"}>
        <Row>
          <Col className={"align-content-center " + (!isSub ? "main-scope-name-wrap-up" : "sub-scope-name-wrap-up")}>
            <span
              style={rgbEnabled ? { color: !isSub ? colors.dark : colors.primary, fontWeight: "bold" } : {}}
              className={!rgbEnabled ? (!isSub ? "main-scope-name-color-wrap-up" : "sub-scope-name-color-wrap-up") : ""}
            >
              {item.name}
            </span>
          </Col>
          <Col xs={"auto"} className={"align-content-center"} style={{ display: "inline-block", float: "right" }}>
            <div
              className={!isSub ? "main-scope-score-wrap-up" : "sub-scope-score-wrap-up"}
              style={
                rgbEnabled
                  ? {
                      backgroundColor: colors.primary,
                      color: "#ffffff",
                      border: `2px solid ${colors.dark}`,
                    }
                  : {}
              }
            >
              {elementScore}
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={8} className={"align-content-center"}>
        <Row>
          {item.scale.ranges.map((range, i) => {
            let isHit = range.isHit;
            return (
              <Col
                key={i + "-" + range.id + "scopeScale"}
                className={
                  isHit
                    ? rgbEnabled
                      ? "scale-style-wrap-up"
                      : `scale-style-wrap-up ${!isSub ? "hit-scale" : "hit-sub-scale"}`
                    : "scale-style-wrap-up"
                }
                style={
                  isHit && rgbEnabled
                    ? {
                        backgroundColor: colors.light,
                        borderColor: colors.primary,
                        border: `2px solid ${colors.primary}`,
                        color: colors.dark,
                        fontWeight: "bold",
                      }
                    : {}
                }
              >
                {isHtml ? <div dangerouslySetInnerHTML={{ __html: range.text }} /> : range.text}
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
